import React from "react";
import { Navbar } from "./Navbar";


const TodoListHeader = () => {
    return (
        <>
         <header>
        <h1>TodoList</h1>
      </header>

      <Navbar />
        </>
    )
}

export default TodoListHeader;